export default __webpack_public_path__ + "static/media/pod-marker.788ce8e8.png";